module.exports = __webpack_public_path__ + "static/media/9DESA23.8e6c3286.jpg";